import { Injectable } from "@angular/core";
import {
  addDoc,
  collection,
  doc,
  Firestore,
  getDocs,
  query,
  updateDoc,
  where,
} from "@angular/fire/firestore";

export interface UserAdmin {
  id?: string;
  uid: string;
  email: string;
  ativo: boolean;
  nome?: string;
  createdAt?: string;
}

@Injectable({
  providedIn: "root",
})
export class UserAdminService {
  private collectionName = "user_admin";

  constructor(private firestore: Firestore) {}

  async getByUid(uid: string): Promise<UserAdmin | null> {
    const collectionRef = collection(this.firestore, this.collectionName);
    const q = query(collectionRef, where("uid", "==", uid));
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return null;
    }
    const snap = snapshot.docs[0];
    return { id: snap.id, ...(snap.data() as Omit<UserAdmin, "id">) };
  }

  async getByEmail(email: string): Promise<UserAdmin | null> {
    const collectionRef = collection(this.firestore, this.collectionName);
    const q = query(
      collectionRef,
      where("email", "==", email.trim().toLowerCase())
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return null;
    }
    const snap = snapshot.docs[0];
    return { id: snap.id, ...(snap.data() as Omit<UserAdmin, "id">) };
  }

  async create(data: Omit<UserAdmin, "id">): Promise<string> {
    const collectionRef = collection(this.firestore, this.collectionName);
    const payload = {
      ...data,
      email: data.email.trim().toLowerCase(),
      ativo: data.ativo ?? true,
      createdAt: data.createdAt ?? new Date().toISOString(),
    };
    const docRef = await addDoc(collectionRef, payload);
    await updateDoc(docRef, { id: docRef.id });
    return docRef.id;
  }

  async setAtivo(id: string, ativo: boolean): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    await updateDoc(docRef, { ativo });
  }
}
